import {
  _delete, _get, _patch, _post, _save,
  getUrlQueryParameterFromObject,
} from 'frontcore/utils/communications/apiClient'

export const URL_BASE_ALERT_TEMPLATES = 'alert-templates'
export const URL_BASE_ALERTS_LEVELS = 'alert-levels'
export const URL_BASE_ALERTS = 'alerts'
export const URL_BASE_ALERTS_BY_CHECKPOINT = 'alerts-by-check-point'

export function getAlertTemplates () {
  const url = `${URL_BASE_ALERT_TEMPLATES}/?format=expanded`
  return _get(url)
}

export function getAlertTemplateById (id) {
  const url = `${URL_BASE_ALERT_TEMPLATES}/${id}/?format=expanded`
  return _get(url)
}

export function saveAlertTemplate (data) {
  const url = `${URL_BASE_ALERT_TEMPLATES}/`
  return _save(url, data, true)
}

export function deleteAlertTemplateById (id) {
  const url = `${URL_BASE_ALERT_TEMPLATES}/${id}/`
  return _delete(url)
}

export function patchAlertTemplateById (id, data) {
  const url = `${URL_BASE_ALERT_TEMPLATES}/${id}/?format=expanded`
  return _patch(url, data)
}

export function getAlertLevels () {
  const url = `${URL_BASE_ALERTS_LEVELS}/?ordering=-next_level`
  return _get(url)
}

export function getAlertLevelById (id) {
  const url = `${URL_BASE_ALERTS_LEVELS}/${id}/`
  return _get(url)
}

export function saveAlertLevel (data) {
  const url = `${URL_BASE_ALERTS_LEVELS}/`
  return _save(url, data, true)
}

export function deleteAlertLevelById (id) {
  const url = `${URL_BASE_ALERTS_LEVELS}/${id}/`
  return _delete(url)
}

export function patchAlertLevelById (id, data) {
  const url = `${URL_BASE_ALERTS_LEVELS}/${id}/`
  return _patch(url, data)
}

export function getAlerts (parameters) {
  const queryParams = getUrlQueryParameterFromObject(parameters, false)
  const url = `${URL_BASE_ALERTS}/${queryParams ? '?' + queryParams : ''}`
  return _get(url)
}

export function getAlertById (id) {
  const url = `${URL_BASE_ALERTS}/${id}/?format=expanded`
  return _get(url)
}

export function patchAlertById (id, data) {
  const url = `${URL_BASE_ALERTS}/${id}/`
  return _patch(url, data)
}

export function saveAlert (data) {
  const url = `${URL_BASE_ALERTS}/`
  return _save(url, data, true)
}

export function deleteAlertById (id) {
  const url = `${URL_BASE_ALERTS}/${id}/`
  return _delete(url)
}

export function escalateAlert (id, data) {
  const url = `${URL_BASE_ALERTS}/${id}/escalate/`
  return _post(url, data)
}
